import { displayLabel } from "../../../utils/displayLabel";
import { sectionWrap, escapeHtml } from "./factories";

export function makeBookCardBlock(accentColor, opts = {}) {
  const {
    title = "Your Book Title",
    coverSrc = "",
    buyUrl = "",
    buyLabel = "Buy Now",
    layout = "left",
    border = false,
  } = opts;

  const coverImg = coverSrc
    ? `<img src="${escapeHtml(coverSrc)}" alt="${escapeHtml(displayLabel(title))}" data-thumb style="width:140px;height:auto;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.15);display:block;cursor:pointer;" onclick="window.__bcHandleImageClick && window.__bcHandleImageClick(this)" />`
    : `<div data-image-slot data-cover-slot contenteditable="false" onclick="window.__bcImageSlotClick && window.__bcImageSlotClick(this)" style="width:140px;height:200px;border:2px dashed rgba(0,0,0,0.15);border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;background:rgba(0,0,0,0.03);"><div style="text-align:center;color:rgba(0,0,0,0.35);font-size:10px;pointer-events:none;"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin:0 auto 3px;"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><path d="m21 15-5-5L5 21"></path></svg><div>Add cover</div></div></div>`;

  const flexDir = layout === "right" ? "row-reverse" : "row";

  return sectionWrap(
    `
    <div data-book-layout="${layout}" data-book-border="${border ? 'true' : 'false'}" style="
      display:flex;
      flex-direction:${flexDir};
      gap:20px;
      align-items:flex-start;
      padding:20px;
      border:${border ? '1px solid #d8d1c5' : 'none'};
      border-radius:14px;
      margin:18px 0;
    ">
      <div style="flex-shrink:0;" data-book-cover>
        <a href="${escapeHtml(buyUrl || '#')}" target="_blank" rel="noopener noreferrer" style="text-decoration:none;">
          ${coverImg}
        </a>
      </div>
      <div style="flex:1;min-width:0;">
        <h3
          contenteditable="true"
          data-bc-focus="1"
          data-placeholder="Book Title"
          style="margin:0 0 8px 0;font-size:20px;font-weight:700;line-height:1.3;"
        >${escapeHtml(displayLabel(title))}</h3>
        <p
          contenteditable="true"
          data-placeholder="Add a book description or blurb..."
          style="margin:0 0 16px 0;font-size:14px;line-height:1.6;opacity:0.8;"
        ></p>
        <a href="${escapeHtml(buyUrl || "#")}"
          data-bc-accent
          data-bc-button
          data-btn-label="${escapeHtml(buyLabel)}"
          data-btn-url="${escapeHtml(buyUrl)}"
          data-buy-url="${escapeHtml(buyUrl)}"
          data-buy-label="${escapeHtml(buyLabel)}"
          ${!buyUrl ? 'data-placeholder-link' : ''}
          target="_blank"
          rel="noopener noreferrer"
          onclick="event.preventDefault(); window.__bcButtonClick && window.__bcButtonClick(this)"
          style="
            display:inline-block;
            background:${accentColor};
            color:#ffffff;
            padding:10px 22px;
            border-radius:8px;
            text-decoration:none;
            font-weight:700;
            font-size:14px;
            cursor:pointer;
          ">
          ${escapeHtml(buyLabel)}
        </a>
      </div>
    </div>
    `,
    "book-card"
  );
}
